import { withLDProvider as originalWithLDProvider } from 'launchdarkly-react-client-sdk'
import { flags } from './withLDProvider.consts'

export const withLDProvider = <T extends React.JSX.IntrinsicAttributes>(WrappedComponent: React.ComponentType<T>) =>
  originalWithLDProvider<T>({ clientSideID: process.env.LAUNCHDARKLY_ID, flags })(WrappedComponent)
